import { render } from "./TipsTrajectory.vue?vue&type=template&id=5e42f7be"
import script from "./TipsTrajectory.vue?vue&type=script&lang=js"
export * from "./TipsTrajectory.vue?vue&type=script&lang=js"
script.render = render

export default script